/**
 * Shared UI component for UI Loader Outlet.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { UiLoaderService } from './ui-loader.service';

/**
 * COMPONENT: Ui Loader Outlet
 * Inputs: Uses the parameters, injected services, route state, or signal state declared by this file.
 * Output: Returns the documented value or updates component/service state without changing the public contract.
 * Processing: Documents the Angular declaration that connects this class to templates, dependency injection, or template transforms.
 */
@Component({
  selector: 'ui-loader-outlet',
  standalone: true,
  template: `
    @if (loaderService.loading()) {
      <div class="ui-loader-backdrop">
        <div class="ui-loader-spinner"></div>
      </div>
    }
  `,
  styles: [`
    .ui-loader-backdrop {
      position: fixed;
      inset: 0;
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.55);
      backdrop-filter: blur(2px);
    }

    .ui-loader-spinner {
      width: 44px;
      height: 44px;
      border: 4px solid #e3eaf5;
      border-top-color: #1e88e5;
      border-radius: 50%;
      animation: ui-spin 0.7s linear infinite;
    }

    @keyframes ui-spin {
      to { transform: rotate(360deg); }
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiLoaderOutletComponent {
  protected readonly loaderService = inject(UiLoaderService);
}
